// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6979) return "static/chunks/6979-5e418d3bcdc344fd.js";
	if (chunkId === 563) return "static/chunks/563-f01327fdecfde41a.js";
	if (chunkId === 6589) return "static/chunks/6589-3c102e1e56de9dce.js";
	if (chunkId === 7942) return "static/chunks/7942-abc9bbdd829d1468.js";
	if (chunkId === 1868) return "static/chunks/1868-fb0116753b31dfee.js";
	if (chunkId === 10) return "static/chunks/10-03cd0152e52fd1d1.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"302":"ef8f3e0897c20606","754":"435086386f9bad0c","1053":"f40cbec985c3205d","1822":"82a42c3a2ff06015","1853":"3328f6662ec816bc","2661":"c7abdab6e53a68d8","4980":"2d7d757a77067f53","6182":"4c91381a0fbf945c","6540":"b861c10fb87fdcf4","8406":"0df9febb65152b46","8968":"1a93335f8d880bd6","9760":"6f7f27577fd76e7c"}[chunkId] + ".js";
};